import { CompanyDexie } from "../interfaces/companyDexie";
import { clearData } from "./clearData";

export async function addCompanies(companies: CompanyDexie[], thisCompanies): Promise<void> {
    await clearData(thisCompanies)
    await thisCompanies.bulkPut(companies);
}